/**
 * Shared parsing for the `|`-separated, `*`-wildcard solution search query
 * used across the Demand and SSM tabs.
 */

// Lookups may contain characters typed by the user that aren't valid regex
// syntax (unbalanced brackets/parens) — treat those as matching nothing
// rather than letting `new RegExp` throw during render.
export function lookupToRegex(lookup: string): RegExp | null {
  const withWildcard = `${lookup}*`.replace(/\*/g, ".*");
  try {
    return new RegExp(`^${withWildcard}$`);
  } catch {
    return null;
  }
}

export function splitSolutionQuery(query: string): string[] {
  return query.replace(/\s/g, "").split("|").filter(Boolean);
}

/** Compiles a (possibly multi/wildcard) query into its match regexes. */
export function solutionRegexes(query: string): RegExp[] {
  return splitSolutionQuery(query)
    .map(lookupToRegex)
    .filter((re): re is RegExp => re !== null);
}

/** Returns which of `candidates` match the (possibly multi/wildcard) query, sorted. */
export function resolveSolutionNames(query: string, candidates: Iterable<string>): string[] {
  const regexes = solutionRegexes(query);
  const matches = new Set<string>();
  for (const candidate of candidates) {
    if (regexes.some((re) => re.test(candidate))) matches.add(candidate);
  }
  return [...matches].sort();
}
